firebird.service('localizationService', [
    '$q',
    '$rootScope',
    '$translate',
    'logService',
    'helperService',
    'config',
    'localeService',
    function ($q, $rootScope, $translate, logService, helperService, config, localeService) {
        const logger = new LogServiceWrapper(logService, 'localizationService');

        $rootScope.$on('$translateLoadingError', onTranslateLoadingError);
        $rootScope.$on('$translateLoadingSuccess', onTranslateLoadingSuccess);
        $rootScope.$on('$translateChangeSuccess', onTranslateChangeSuccess);
        $rootScope.$on('$translateChangeError', onTranslateChangeError);

        //Don't forget to add file link into app/templates/index.htm for caching purpose.
        //See <!-- Localization data--> section.
        //<script type="application/json" src="i18n/minify/{new culture code}.json"></script>

        var cultureCodesMapping = {};
        cultureCodesMapping['en-us'] = 'en-US';
        cultureCodesMapping['en-gb'] = 'en-GB';
        cultureCodesMapping['en-au'] = 'en-GB';
        cultureCodesMapping['de-de'] = 'de-DE';
        cultureCodesMapping['es-es'] = 'es-419';
        cultureCodesMapping['es-419'] = 'es-419';
        cultureCodesMapping['fr-ca'] = 'fr-CA';
        cultureCodesMapping['ja-jp'] = 'ja-JP';
        cultureCodesMapping['it-it'] = 'it-IT';
        cultureCodesMapping['nl-nl'] = 'nl-NL';
        cultureCodesMapping['ru-ru'] = 'ru-RU';

        var enLocales = ['en-us', 'en-gb', 'en-au'];

        var currentLocalization = 'en-US';
        var localizationInitPromise = $q.defer();

        function onTranslateLoadingError(e, data) {
            logger.error('onTranslateLoadingError', 'Failed to load language by code', data.language);
            setDefault();
        }

        function onTranslateLoadingSuccess(e, data) {
            logService.log('Successfully loaded language with code: ' + data.language);
        }

        function onTranslateChangeSuccess(data) {
            logService.log('Successfully applied localization for language: ' + data.language);
            localizationInitPromise.resolve(data);
        }

        function onTranslateChangeError(data) {
            logger.error('onTranslateChangeError', 'Failed to apply localization for language', data.language);
            localizationInitPromise.reject(data);
        }

        function setDefault() {
            $translate.use('en-US').then(
                function (code) {
                    currentLocalization = code;
                    logService.log('Successfully set language to default:' + code);
                },
                function (code) {
                    currentLocalization = '';
                    logger.error('setDefault', 'Set language to default failed', code);
                }
            );
            localeService.setActiveLanguage('en-US');
        }

        function resolveCultureCode(code) {
            var cultureCode = cultureCodesMapping[code.toLowerCase()];
            if (cultureCode) {
                return cultureCode;
            }

            var supportedCode = Object.keys(cultureCodesMapping).find(function (value) {
                return value.startsWith(code.toLowerCase());
            });
            if (supportedCode) {
                return cultureCodesMapping[supportedCode];
            }

            logger.warn('resolveCultureCode', 'key not available for localization', code);
            return 'en-US';
        }

        this.initialized = function () {
            return localizationInitPromise.promise;
        };

        this.setLocalization = function (code) {
            if (!isLocalizationEnabled()) {
                return;
            }

            var localizationKey = resolveCultureCode(code);

            $translate.use(localizationKey).then(
                function (code) {
                    currentLocalization = code;
                    logService.log('Successfully changed language to: ' + code);
                },
                function (code) {
                    logger.error('setLocalization', 'Failed to changed language to', code);
                }
            );
            localeService.setActiveLanguage(localizationKey);
        };

        this.getLocalization = function () {
            return currentLocalization;
        };

        this.isEnLocale = function () {
            return enLocales.indexOf(currentLocalization.toLowerCase()) >= 0;
        };

        this.translate = function (key, interpolateParams) {
            return $translate.instant(key, interpolateParams);
        };

        // temporary config function and should be removed after webinar localization release
        function isLocalizationEnabled() {
            if (helperService.getMeetingTypeByDomain() !== 'webinar') {
                return true;
            }

            if (!config || !config.isWebinarLocalizationEnabled) {
                return false;
            }

            var environment = helperService.getEnvironment();
            return config.isWebinarLocalizationEnabled[environment] || config.isWebinarLocalizationEnabled.prod;
        }
    }
]);
